import React, { useContext } from 'react'
import { Navigate } from 'react-router'

import { AuthContext } from 'features/auth'
import { useProjectStore } from 'features/project/store'
import type { ClientAuthRole } from 'src/types/auth-role'
import { getEffectiveRole, isRoleAllowed } from 'src/types/auth-role'
import type { ClientSettings, ProjectState } from 'types/project'

type Props = {
  allowlist: ClientAuthRole[]
  pageKey: keyof ClientSettings['project']['pages']
  children: React.ReactNode
}

export const RoleGuard = ({
  allowlist,
  pageKey,
  children,
}: Props): JSX.Element => {
  const { userDetails } = useContext(AuthContext)
  const projectId = useProjectStore((s: ProjectState) => s.projectId)
  const details = useProjectStore((s: ProjectState) => s.details)
  const effective = getEffectiveRole(
    details?.role,
    !!userDetails?.yogi_user,
    userDetails?.role,
  )
  const isHiddenByPageSettings =
    details?.clientSettings?.project?.pages?.[pageKey]?.hidden === true
  if (isHiddenByPageSettings || !isRoleAllowed(effective, allowlist)) {
    return <Navigate to={`/project/${projectId}`} replace />
  }
  return <>{children}</>
}
